const cabinetBulkEditBehavior = async (source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const {
    selection = {},
    content: patch
  } = transientContext;
  let numItems = 0;
  const formTypeIdentifiers = Object.keys(selection);
  for (let i = 0; i < formTypeIdentifiers.length; i += 1) {
    const formTypeIdentifier = formTypeIdentifiers[i];
    const formIDs = selection[formTypeIdentifier];
    for (let j = 0; j < formIDs.length; j += 1) {
      const formID = formIDs[j];
      // eslint-disable-next-line no-await-in-loop
      await sourceEvaluator({
        type: 'patchContentBehavior',
        id: formID,
        patches: [patch]
      });
      numItems += 1;
    }
  }
  const addedString = numItems === 1 ? '1 item' : `${numItems} items`;
  await sourceEvaluator({
    type: 'alertBehavior',
    message: `${addedString} updated.`,
    options: [{
      title: 'OK'
    }]
  });
};
module.exports = {
  evaluate: cabinetBulkEditBehavior
};